<ion-content scrollY="false">
  <ion-list lines="full">

    @if (permissionService.isPermitted('pos-orders-refunds-payments-add-payment') && (order_refund_page.refund.payment_status == 'unpaid' || order_refund_page.refund.payment_status == 'partially_paid')) {
      <ion-item button="true" (click)="presentOrderRefundPaymentAddModal()">
        <ion-label><fa-icon [icon]="['fal', 'plus']" size="lg" [fixedWidth]="true"></fa-icon>Add payment</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-orders-refunds-edit-refund')) {
      <ion-item button="true" (click)="presentOrderRefundEditModal()">
        <ion-label><fa-icon [icon]="['fal', 'pencil']" size="lg" [fixedWidth]="true"></fa-icon>Edit</ion-label>
      </ion-item>
    }

  </ion-list>
</ion-content>
